export const GROUP_SORT_DATA = [
  {
    sortId: 'A_TO_Z',
    name: 'A -> Z'
  },
  {
    sortId: 'Z_TO_A',
    name: 'Z -> A'
  },
  {
    sortId: 'MORE_TO_LESS',
    name: 'More To Less'
  },
  {
    sortId: 'LESS_TO_MORE',
    name: 'Less To More'
  }
]

export const GROUP_UPDATE_HANDLERES = {
  ATTRIBUTE: 'ATTRIBUTE',
  SORT: 'SORT',
  DRAG: 'DRAG',
  REMOVE_GROUP: 'REMOVE_GROUP',
  ADD_GROUP: 'ADD_GROUP',
  CLEAR_ALL: 'CLEAR_ALL'
}
